import React from "react";
import "./MapSection.css";

export default function MapSection() {
  return (
    <section className="densat-map-section">
      <div className="densat-map-container">
        <iframe
          title="Densat FM Services Location"
          src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d467148.77807008126!2d75.09524700000001!3d23.832825!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390ce3dca3ffffff%3A0x63c7e9d68787ee1f!2sDensat%20FM%20Services%20Pvt%20Ltd!5e0!3m2!1sen!2sus!4v1766033114780!5m2!1sen!2sus"
          loading="lazy"
          allowFullScreen
          referrerPolicy="no-referrer-when-downgrade"
        />
      </div>
    </section>
  );
}
